/**
 * Nearby Chip Component
 *
 * Toggle chip that uses browser geolocation (with profile city fallback)
 * to filter search results by proximity.
 */

export function nearbyChip() {
    return {
        active: false,
        location: '',
        radius: '50',

        init() {
            // Restore state from URL params
            const params = new URLSearchParams(window.location.search);
            const loc = params.get('location');
            if (loc && loc.includes(',')) {
                this.location = loc;
                this.radius = params.get('radius') || '50';
                this.active = true;
            }
        },

        toggle() {
            if (this.active) {
                this.active = false;
                this.location = '';
                this.submitForm();
                return;
            }

            this.requestLocation();
        },

        clearLocationFilters() {
            const form = this.$el.closest('form');
            if (!form) return;

            // Remove country hidden inputs
            form.querySelectorAll('input[name="countries[]"]').forEach(el => el.remove());
            const countryEl = form.querySelector('[x-data*="countryChips"][x-data*="countries"]');
            if (countryEl?._x_dataStack) {
                countryEl._x_dataStack[0].countries = [];
            }

            // Clear city
            const cityEl = form.querySelector('[x-data*="cityFilter"]');
            if (cityEl?._x_dataStack) {
                cityEl._x_dataStack[0].clearCity();
            }
            const cityInput = form.querySelector('input[name="city"]');
            const cityNameInput = form.querySelector('input[name="cityName"]');
            if (cityInput) cityInput.value = '';
            if (cityNameInput) cityNameInput.value = '';

            // Clear continents
            form.querySelectorAll('input[name="continents[]"]').forEach(cb => {
                const chip = cb.closest('.filter-checkbox-chip');
                if (chip?._x_dataStack) {
                    chip._x_dataStack[0].on = false;
                }
                cb.checked = false;
            });
        },

        submitForm() {
            this.$nextTick(() => {
                if (this.active) {
                    this.clearLocationFilters();
                }
                this.$el.closest('form')?.submit();
            });
        },

        requestLocation() {
            if (!navigator.geolocation) {
                this.fallbackToProfileCity();
                return;
            }

            navigator.geolocation.getCurrentPosition(
                (pos) => {
                    this.location = pos.coords.latitude + ',' + pos.coords.longitude;
                    this.active = true;
                    this.submitForm();
                },
                () => {
                    this.fallbackToProfileCity();
                },
                { timeout: 8000, maximumAge: 300000 }
            );
        },

        fallbackToProfileCity() {
            const form = this.$el.closest('form');
            const fallback = form?.dataset.userLocation;
            if (fallback) {
                this.location = fallback;
                this.active = true;
                this.submitForm();
            } else {
                this.active = false;
            }
        }
    };
}
